// summaryUtils.js

// ---------- Label & text helpers ----------
export function decodeHtml(str) {
  if (!str) return str;
  return String(str)
    .replaceAll("&amp;", "&")
    .replaceAll("&lt;", "<")
    .replaceAll("&gt;", ">")
    .replaceAll("&#39;", "'")
    .replaceAll("&quot;", '"');
}

export function normalizeBW(bg) {
  const s = (bg || "").toLowerCase().trim();
  if (s.includes("beauty")) return "Personal care";
  if (s.includes("home")) return "Homecare";
  if (s.includes("food")) return "Foods";
  if (s.includes("others")) return "BWB";
  return bg || "";
}

// ---------- Formatters ----------
export function formatNumber(n) {
  if (n === null || n === undefined) return "-";
  const v = Number(n);
  if (!Number.isFinite(v)) return "-";
  const abs = Math.abs(v);
  if (abs >= 1_000_000_000) return (v / 1_000_000_000).toFixed(2).replace(/\.00$/, "") + "B";
  if (abs >= 1_000_000)      return (v / 1_000_000).toFixed(2).replace(/\.00$/, "") + "M";
  if (abs >= 1_000)          return (v / 1_000).toFixed(2).replace(/\.00$/, "") + "K";
  return String(Math.round(v));
}

export function formatPercent(n) {
  if (n === null || n === undefined) return "-";
  const v = Number(n);
  if (!Number.isFinite(v)) return "-";
  return `${Math.round(v)}%`;
}

// ---------- Constants (customize once, reuse everywhere) ----------
export const SUMMARY_PERCENT_COLS = [
  "Allocation %",
  "Predictive Allocation %"
];

export const SUMMARY_NUM_COLS = [
  "Order",
  "Delivery",
  "Invoiced",
  "Allocation Loss",
  "Feasible Loss Mitigation",
];

// ---------- Data shaping ----------
export function groupByBG(rows) {
  const groups = new Map();
  (rows || []).forEach((row) => {
    const bgKey = decodeHtml(row?.["BG"]) || "";
    if (!groups.has(bgKey)) groups.set(bgKey, { total: null, children: [] });
    if (row?.is_bg_total) groups.get(bgKey).total = row;
    else groups.get(bgKey).children.push(row);
  });
  const orderedBGs = Array.from(groups.keys());
  return { groups, orderedBGs };
}

// ---------- UI helpers ----------
export function initOpenState(orderedBGs) {
  const init = {};
  (orderedBGs || []).forEach((bg) => { init[bg] = false; });
  return init;
}